import { get } from 'lodash';
import ImageGallery, { GalleryElement } from 'components/Content/Previews/ImageGallery';

interface ImageGalleryPreviewProps {
  formValues: (ContentContainer | Attraction | Venue) & { galleryHeader?: string };
  fieldName?: string;
  hideHeader?: boolean;
}

function ImageGalleryPreview({
  formValues,
  fieldName = 'imagesAttributes',
  hideHeader = false,
}: ImageGalleryPreviewProps) {
  const slides = get(formValues, fieldName) as GalleryElement[] | undefined;

  return <ImageGallery header={hideHeader ? null : (formValues?.galleryHeader ?? null)} slides={slides ?? []} />;
}

export default ImageGalleryPreview;
